angular.module('app').controller('CustomLineItemCtrl', function($http, order, line_item, $mdToast, $mdDialog, $route) {
    "ngInject";

    var main = this;
    var url ='/api/v1/admin/line_item';
    var method = 'POST';
    var message = "Added line item";
    if(line_item.id) {
        main.item = line_item;
        url += '/' + main.item.id;
        method = 'PUT';
        message = "Saved line item";
    } else {
        main.item = {
            'type': 'custom',
            'order_id': order.id,
            'options': {}
        };
    }

    main.save = function() {
        if(main.saving) {
            var alert = $mdToast.simple().textContent("Save already in progress");
            $mdToast.show(alert);
            return;
        }

        if(!order.id) {
            $mdDialog.hide(main.item);
            return;
        }

        main.saving = true;
        var data = angular.copy(main.item);
        delete data.item;

        $http({'method': method, 'url': url, 'data': data}).then(
            function(response) {
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
                $mdDialog.hide(response.data);
                $route.reload();
            },
            function() {
                main.saving = false;
            }
        );
    }
});
